import { useEffect, useState, useRef } from "react";
import "./Counter.css";


function Counter({ target }) {
  const [count, setCount] = useState(0);
  const ref = useRef();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) setVisible(true);
    });

    observer.observe(ref.current);

    return () => observer.disconnect();
  }, []);

  useEffect(() => {
    if (!visible) return;

    let start = 0;
    const timer = setInterval(() => {
      start += target / 50;

      if (start >= target) {
        setCount(target);
        clearInterval(timer);
      } else {
        setCount(Math.floor(start));
      }
    }, 30);
  }, [visible, target, ]);

  return <h2 ref={ref}>{count}+</h2>;
}

export default function Stats() {
  return (
    <section className="stats">
      <div className="stat">
        <Counter target={50000} />
        <p>Engagements</p>
      </div>

      <div className="stat">
        <Counter target={1500} />
        <p>Users</p>
      </div>

      <div className="stat">
        <Counter target={24} />
        <p>Active Support</p>
      </div>

      <div className="stat">
        <Counter target={100} />
        <p>% Satisfied</p>
      </div>
    </section>
  );
}